import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes';
import { HelmetProvider } from 'react-helmet-async';
import Analytics from './components/Analytics';

const App = () => {
  const analyticsId = process.env.REACT_APP_ANALYTICS_ID;

  if (!analyticsId) {
    console.warn('Analytics ID is not configured');
  }

  return (
    <HelmetProvider>
      <Router>
        {analyticsId && <Analytics measurementId={analyticsId} />}
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}

export default App;